<template>
  <div ref="dataBody"
       :class="cssClass"
       :style="'pointer-events: auto; padding-left:' + pinnedColumnsWidth +'px; display:flex; flex-flow:column; min-width: 100%; width:' + (hScrollSize) + 'px'"
       data-test-path="data-body">

    <div v-for="row in rows"
         :key="'r' + sId + '-' + row.uid"
         :class="(focusOnIndex === row.index ? 'bgr-row bgr-focus' : row.index%2 ? 'bgr-row bgr-odd' : 'bgr-row bgr-even') + (cssV > 0 ? row.cssClass: '')"
         :data-row="row.index"
         :style="'min-width: 100%; height:' + rowHeight + 'px; width:' + hScrollSize + 'px; order:' + row.flexOrder"
         tabindex="-1"
         @dblclick="doubleClick($event, row)"
         @keydown="keyDown($event, row)"
         @mousedown="focusRow($event, row)"
    >

      <div v-for="col in activeColumns"
           :key="sId + '-' + row.uid + '-' + col.id"
           :class="'bgr-cell '  +
        (col.editorComponent ? 'bgr-editable' : '')"
           :data-col="activeColumns.indexOf(col)"
           :style="'height:' + rowHeight + 'px; width:' + (col.size + 1) + 'px'"
      >
        <div :ref="sId + '-' + row.uid + '-' + col.id"
             :style="'width: ' + (col.size) + 'px; height: ' + rowHeight + 'px; ' + calcStyle(row, col)"
             class="bgr-cell-b"
             tabindex="-1"
             @click="click($event, row, col)"
             @focusin="mouseOver($event, row, col)"
             @focusout="mouseOut($event, row, col)"
             @mouseenter="mouseOver($event, row, col)"
             @mouseleave="mouseOut($event, row, col)">

          <div v-if="showGlassRow === row && showGlassCol === col && col.size > 26"
               style="display: block; position: relative; width: 0; height: 0">
            <b-button :style="'outline: none; position: absolute; left: ' + (col.size - 34) + 'px; top:-10px'"
                      class="readMore"
                      size="sm"
                      @mouseenter="focusOnReadMore"
                      @click.stop="readMore($event)">...
            </b-button>
          </div>

          <BgCell ref="cells"
                  :column="col"
                  :data="source"
                  :model="row.data"
                  :prop="col.prop"
                  :row-index="row.index"
                  :row-uid="row.uid"
                  :hasLinkFlag="hasLinkFlag"
          ></BgCell>

        </div>
        <div :style="'width: 1px; height: ' + rowHeight + 'px'" class="colSpacer"></div>
      </div>
    </div>
  </div>

</template>
<style>

.no-frame {
  outline: none;
}

div.bgr-row {
  display: flex;
  flex-flow: row;
  overflow: hidden;
  outline: none;
}

div.bgr-cell {
  display: flex;
  overflow: hidden;
}

div.bgr-cell-b {
  overflow: hidden;
  display: flex;
  align-items: center;
}

div.brg-c-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>
<script>

import {collectTexts, DEBUG, getScrollbarSize} from "@/components/baseGrid/GridTools";
import BgCell from "@/components/baseGrid/BgCell.vue";
import RtModule from "@/utils/RtModule";
import SimpleFormColorTest from "@/server/com/silkplm/model/healthcheck/SimpleFormColorTest";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import DataStream from "@/components/forms/DataStream";

let ctr = 0;

export default {
  name: "Section",
  components: {BgCell},

  async created() {

  },

  mounted() {
  },

  methods: {
    calcStyle(row, column) {
      let rowData = this.source[row.index];
      if (column.cellProperties) {
        let cellConfig;
        if (!row?.data) {
          return "";
        }
        if (this.form.isView) {
          if (!column.fieldConfig.enabledStyles) {
            return "";
          }
        }
        if (this.form.isView) {
          if (column?.fieldConfig?.styleFunction) {
            let style = RtModule()[column.fieldConfig.styleFunction].call(column.prop, row.data, this.form, column);
            if (!style) {
              return "";
            }
            const styleString = Object.entries(style)
                .map(([key, value]) => `${key}: ${value};`)
                .join(' ');
            return styleString;
          }
        } else {
          cellConfig = column.cellProperties({prop: column.prop, model: rowData, data: this.source, column});
        }
        if (!cellConfig) {
          return "";
        }
        let dynamicStyle = cellConfig?.style ?? {};
        let styleExpression = "";
        for (const style in dynamicStyle) {
          styleExpression += style + ":" + dynamicStyle[style] + "; ";
        }
        return styleExpression;
      }
      return "";
    },

    mouseOver(ev, row, col) {
      let target = ev.target;
      if (target.tagName === "BUTTON") {
        return;
      }

      if (target.children.length > 0) {
        target = target.children[0];
      }

      if (!col.fieldConfig ||
          (col.fieldConfig.gridColTemplateComponent != null &&
              col.fieldConfig.gridColTemplateComponent !== 'GRID_VALUE_ATTRIBUTES')) {
        this.showGlassCol = null;
        this.showGlassRow = null;
        return;
      }
      if (target?.offsetHeight > 44 || (target?.offsetWidth + 4) > col.size) {
        this.showGlassCol = col;
        this.showGlassRow = row;
      } else {
        this.showGlassCol = null;
        this.showGlassRow = null;
      }
    },
    mouseOut(ev, row, col) {
      this.showGlassCol = null;
      this.showGlassRow = null;
    },
    focusOnReadMore(ev) {
      ev.target.focus();
    },
    readMore(ev) {
      let text = '';
      if (this.showGlassCol.fieldConfig.gridColTemplateComponent == null) {
        text = ev.target.parentNode.parentNode.querySelector("span").innerHTML;
      } else if (this.showGlassCol.fieldConfig.gridColTemplateComponent === 'GRID_VALUE_ATTRIBUTES') {
        text = collectTexts(ev.target.parentNode.parentNode.querySelector(".container"));
      }
      DialogManager.info(this.showGlassCol.name, text);
      this.showGlassCol = null;
      this.showGlassRow = null;
    },
    forceRequestData() {
      this.$refs.cells?.forEach(cell => {
        cell.forceRequestData();
      });
    },
    refreshView() {
      let notified = false;
      this.$refs.cells?.forEach(cell => {
        let wasPending = cell.currentModel?.__pending__;
        cell.touch();
        if (!notified) {
          let isPending = cell.currentModel?.__pending__;
          if (wasPending && !isPending) {
            if (this.focusOnIndex === cell.$props.rowIndex) {
              DEBUG && console.log("Selected cell loaded");
              notified = true;
              this.$emit('focusedRowLoaded');
            }
          }
        }
      });
    },
    toLoadedRow(row) {
      return {data: this.source[row.index], index: row.index};
    },
    focusRow(event, row) {
      DEBUG && console.log("Row clicked");
      this.$emit('focusRow', event, this.toLoadedRow(row));
      //this.focusOnIndex = row.index;
    },
    keyDown(event, row) {
      DEBUG && console.log("Keyboard input on row");
      this.$emit('rowKeyDown', event, this.toLoadedRow(row));
    },
    doubleClick(event, row) {
      DEBUG && console.log("Keyboard input on row");
      let enabledDoubleClick = true;
      if (this.form?.enableShowDetailsByDoubleClick === false) {
        enabledDoubleClick = false;
      }
      if (enabledDoubleClick) {
        this.$emit('rowDoubleClick', event, this.toLoadedRow(row));
      }
    },

    click(event, row, col) {
      this.$emit('cellFocus', this.toLoadedRow(row), col, event);
      this.mouseOver(event, row, col);
    },

    show() {
      // requestAnimationFrame(()=>{
      this.cssClass = 'no-frame bgr-rows' + (this.pinned ? ' bgr-pinned y ' : ' y ') + "transition full-opacity";
      // this.$el.classList.add('transition');
      // this.$el.classList.add('full-opacity');
      // this.$el.classList.remove('zero-opacity');
      // this.$el.classList.add('y');
      // })
    },
    hide() {
      this.cssClass = 'no-frame bgr-rows' + (this.pinned ? ' bgr-pinned x ' : ' x ') + "zero-opacity";
      // requestAnimationFrame(()=> {
      //   // this.$el.classList.remove('transition');
      //   // this.$el.classList.remove('full-opacity');
      //   // this.$el.classList.add('zero-opacity');
      //   // this.$el.classList.add('x');
      // });

    },

    onChunkLoaded(offset, windowSize) {
      let cells = this.$refs.cells;
      let notified = false;

      cells?.forEach(cell => {
        const i = cell.$props.rowIndex;
        if (i >= offset && i <= offset + windowSize) {
          let wasPending = cell.currentModel?.__pending__;
          cell.touch();
          if (!notified) {
            let isPending = cell.currentModel?.__pending__;
            if (wasPending && !isPending) {
              if (this.focusOnIndex === cell.$props.rowIndex) {
                DEBUG && console.log("Selected cell loaded");
                notified = true;
                this.$emit('focusedRowLoaded');
              }
            }
          }
        }
      });
      this.cssV++;
      DEBUG && console.log(`Section stream window refresh: offset:${offset}, windowSize:${windowSize}`);
    }
  },

  props: {
    hasLinkFlag: {default: false},
    pinned: {default: false},
    pinnedColumnsWidth: {default: 0},
    hScrollSize: {default: 0},
    rows: {default: () => []},
    source: {default: () => []},
    form: {type: BaseFormConfig},
    rowHeight: {default: 0},
    focusOnIndex: {default: -1},
    /**@type ColumnDefinition[]*/
    activeColumns: {default: () => []},
    headerHeight: {default: 0},
  },

  watch: {},

  data: function () {
    return {
      cssV: 1,
      showGlassRow: null,
      showGlassCol: null,
      sId: ctr++,
      cssClass: 'no-frame bgr-rows' + (this.pinned ? ' bgr-pinned ' : ' ') + 'zero-opacity'
    }
  }
}
</script>


<style scoped>

</style>